var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppIc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19789"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19473",
  transform: "translate(.126 .067)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "none",
  "data-name": "Ellipse 1392",
  transform: "translate(-.126 -.068)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 19772"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.862 15.861a2.03 2.03 0 0 1 2.03-2.03",
  "data-name": "Path 27425"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.862 30.075a2.03 2.03 0 0 0 2.03 2.03",
  "data-name": "Path 27426"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.862 15.86v14.213",
  "data-name": "Line 1709"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.892 13.831h8.122",
  "data-name": "Line 1710"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.892 32.104h6.946",
  "data-name": "Line 1711"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.045 15.861a2.03 2.03 0 0 0-2.03-2.03",
  "data-name": "Path 27427"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.044 15.86v10.152",
  "data-name": "Line 1712"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.968 21.952c2.03 0 2.831 4.061 5.076 4.061",
  "data-name": "Path 27428"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.938 23.982a2.03 2.03 0 0 1 2.03-2.03",
  "data-name": "Path 27429"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.938 23.983c5.076 6.091 2.03 8.122 6.091 10.152",
  "data-name": "Path 27430"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.03 34.135v2.03",
  "data-name": "Line 1713"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.136 36.165v-4.061",
  "data-name": "Line 1714"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.135 32.105c0-6.734 0-9.137-6.091-13.2",
  "data-name": "Path 27431"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.137 36.165H27.03",
  "data-name": "Line 1715"
})))));
export { SvgAppIc as ReactComponent };
export default __webpack_public_path__ + "static/media/app_ic.5b965c265e11245d0d1354eca9a84508.svg";